import { call, put } from "redux-saga/effects";
import {
  fetchCncVoucherReport,
  resendCncVoucher,
} from "../requests/cncVoucher";
import {
  fetchCncVoucherSentReportFailure,
  fetchCncVoucherSentReportSuccess,
  resendCncVoucherFailure,
  resendCncVoucherSuccess,
} from "../../cncVoucher/cncVoucherActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleFetchCncVoucherReport({
  payload: { orderNumber, emailId },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchCncVoucherReport, {
      orderNumber,
      emailId,
    });
    const voucherSentReport = parseCncVoucherReport(response);
    if (voucherSentReport) {
      yield put(fetchCncVoucherSentReportSuccess({ voucherSentReport }));
    } else {
      yield put(fetchCncVoucherSentReportSuccess({ voucherSentReport: {} }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchCncVoucherReport error = ${error}`);
    yield put(fetchCncVoucherSentReportFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseCncVoucherReport = (response) => response?.data?.data[0];

export function* handleResendCncVoucher({ payload: { postBody } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(resendCncVoucher, { postBody });
    const sentSuccessfully = parseResendCncVoucherResponseStatus(response);
    if (sentSuccessfully) {
      yield put(resendCncVoucherSuccess(sentSuccessfully));
    } else {
      yield put(
        resendCncVoucherFailure("Problem Resending, please contact admin")
      );
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleResendCncVoucher error = ${error}`);
    yield put(resendCncVoucherFailure(error));
    yield put(stopLoadingIndicator());
  }
}

const parseResendCncVoucherResponseStatus = (response) =>
  response.status === 200;
